// These values match backend `*Operations`/`*TransitionNames` enums.

export const TaskCustomOperations = {
  transitionCreate: 'create',
  transitionComplete: 'complete',
  transitionReturnToDraft: 'return_to_draft',
} as const;

export const SafetyEventCustomOperations = {
  transitionAssemble: 'assemble',
  transitionPublish: 'publish',
  transitionReopen: 'reopen',
  editPublished: 'edit_published',
} as const;

export const PersonnelCustomOperations = {
  auth: 'authentication',
  perms: 'permissions',
  relatedForms: 'personnel_related_forms',
  limitCompanyScope: 'personnel_company_scope',
  convertUserType: 'personnel_convert_user_type',
  badgeAccess: 'personnel_badge_access',
  badgeAccessAdmin: 'personnel_badge_access_admin',
  printBadge: 'personnel_print_badge',
} as const;

export const VendorCustomOperations = {
  signupUrl: 'signup_url',
  insurance: 'insurance',
} as const;

export const JHACustomOperations = {
  transitionPublish: 'publish',
  transitionManagerApprove: 'manager_approve',
  transitionSafetyApprove: 'safety_approve',
  transitionUnapprove: 'unapprove',
} as const;

export const FormCustomOperations = {
  formSubmissions: 'forms_submissions',
  packageExport: 'forms_package_export',
} as const;

export const AssistantCustomOperations = {
  controlCenter: 'assistant_control_center',
} as const;

export const InspectionCustomOperations = {
  reopen: 'reopen',
  manage: 'manage',
  manageAll: 'manage_all',
  manageSchedules: 'manage_schedules',
  resolveDeficiency: 'deficiency_resolve',
} as const;
